/* Brevielle — scripts propios (mt-). Vanilla JS, sin librerías externas. */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;

    if (reduceMotion) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el, i) {
      el.style.setProperty('--mt-delay', (i % 6) * 0.08 + 's');
      observer.observe(el);
    });
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-mt-count]');
    if (!nums.length) return;

    function animar(el) {
      var target = parseFloat(el.getAttribute('data-mt-count'));
      if (isNaN(target)) return;
      if (reduceMotion) {
        el.textContent = target;
        return;
      }
      var start = 0;
      var duration = 1200;
      var startTime = null;

      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = Math.round(start + (target - start) * eased);
        el.textContent = value;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animar(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    nums.forEach(function (el) { observer.observe(el); });
  }

  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
      if (!principal || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-full');
          var alt = mini.getAttribute('data-alt') || '';
          if (!src) return;
          principal.src = src;
          principal.alt = alt;
          minis.forEach(function (m) { m.classList.remove('is-active'); });
          mini.classList.add('is-active');
        });
      });
    });
  }

  function initCantidad() {
    document.querySelectorAll('[data-mt-cantidad]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var menos = wrap.querySelector('[data-mt-menos]');
      var mas = wrap.querySelector('[data-mt-mas]');
      if (!input) return;
      if (menos) menos.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (mas) mas.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
      var dataEl = root.querySelector('[data-mt-variants-json]');
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var idInput = root.querySelector('input[name="id"]');
      var priceActual = root.querySelector('[data-mt-precio-actual]');
      var priceTachado = root.querySelector('[data-mt-precio-tachado]');
      var submitBtn = root.querySelector('[data-mt-add-to-cart]');
      var optionGroups = root.querySelectorAll('[data-mt-option-index]');

      function selected() {
        var values = [];
        optionGroups.forEach(function (group) {
          var active = group.querySelector('.mt-pill.is-active');
          values.push(active ? active.getAttribute('data-value') : null);
        });
        return values;
      }

      function findVariant(values) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === values[i]; });
        });
      }

      function formatMoney(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
        });
      }

      function refreshAvailability() {
        optionGroups.forEach(function (group, groupIndex) {
          group.querySelectorAll('.mt-pill').forEach(function (pill) {
            var values = selected();
            values[groupIndex] = pill.getAttribute('data-value');
            var match = findVariant(values);
            pill.disabled = !match || !match.available;
          });
        });
      }

      function update() {
        var values = selected();
        var variant = findVariant(values);
        if (!variant) return;

        if (idInput) idInput.value = variant.id;
        if (priceActual) priceActual.textContent = formatMoney(variant.price);
        if (priceTachado) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceTachado.textContent = formatMoney(variant.compare_at_price);
            priceTachado.style.display = '';
          } else {
            priceTachado.style.display = 'none';
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available
            ? submitBtn.getAttribute('data-label-add')
            : submitBtn.getAttribute('data-label-soldout');
        }
        refreshAvailability();
      }

      optionGroups.forEach(function (group) {
        group.querySelectorAll('.mt-pill').forEach(function (pill) {
          pill.addEventListener('click', function () {
            if (pill.disabled) return;
            group.querySelectorAll('.mt-pill').forEach(function (p) { p.classList.remove('is-active'); });
            pill.classList.add('is-active');
            update();
          });
        });
      });

      update();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCifras();
    initGaleria();
    initCantidad();
    initVariantes();
  });
})();
